export const GET_QUIZ_CATEGORIES = "GET_QUIZ_CATEGORIES";
export const GET_QUIZ_CATEGORY_BY_ID = "GET_QUIZ_CATEGORY_BY_ID";
export const UPDATE_QUIZ_CATEGORY = "UPDATE_QUIZ_CATEGORY";
export const DELETE_QUIZ_CATEGORY = "DELETE_QUIZ_CATEGORY";
export const CREATE_QUIZ_CATEGORY = "CREATE_QUIZ_CATEGORY";
